import { render, staticRenderFns } from "./sourceDetailManagement.vue?vue&type=template&id=ff08f430&scoped=true"
import script from "./sourceDetailManagement.vue?vue&type=script&lang=js"
export * from "./sourceDetailManagement.vue?vue&type=script&lang=js"
import style0 from "./sourceDetailManagement.vue?vue&type=style&index=0&id=ff08f430&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff08f430",
  null
  
)

export default component.exports